module.exports = __webpack_public_path__ + "assets/dd99ba95481f114a92db813a978ee90a.png";